export default "__VITE_ASSET__IJCLwvag__"